import React from 'react';
import PropTypes from 'prop-types';
import GlobalModal from 'components/modals/GlobalModal';
import apiClient from 'clients/apiClient';
import compose from 'recompose/compose';
import config from 'helpers/config';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { AlertIcon, RefreshIcon } from 'assets/materialIcons/materialIcons';
import { connect } from 'react-redux';
import { resetUserPasswordFailure, resetUserPasswordSuccess } from 'store/actions/users/userPassword';

class ResetPasswordButton extends React.Component {
    sendResetPasswordRequest = () => {
        const {
            id,
            sendFailure,
            sendSuccess,
        } = this.props;

        const url = `${ config.getApiBaseUrl() }/users/${ id }/reset-password`;

        return apiClient.create(url).then(() => {
            sendSuccess();
        }, () => {
            sendFailure();
        });
    }

    render() {
        const {
            translate,
        } = this.props;

        const actions = [
            {
                icon: <AlertIcon />,
                label: translate('actions.cancel'),
            },
            {
                focus: true,
                label: translate('actions.ok'),
                primary: true,
                onClick: () => {
                    this.sendResetPasswordRequest();
                },
            },
        ];

        return (
            <GlobalModal
                button={ {
                    icon: <RefreshIcon color={ theme.palette.doveGray } />,
                    title: translate('resources.users.actions.reset_password'),
                    primary: true,
                } }
                dialog={ {
                    actions: actions,
                    title: translate('resources.users.reset_password.title'),
                } }
            >
                <p style={ { lineHeight: 1.5 } }>{ translate('resources.users.reset_password.description') }</p>
            </GlobalModal>
        );
    }
}

ResetPasswordButton.propTypes = {
    id: PropTypes.number.isRequired,
    sendFailure: PropTypes.func.isRequired,
    sendSuccess: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        sendFailure: () => {
            dispatch(resetUserPasswordFailure());
        },
        sendSuccess: () => {
            dispatch(resetUserPasswordSuccess());
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(ResetPasswordButton);



// WEBPACK FOOTER //
// ./src/components/button/ResetPasswordButton.js